<template>
  <div>
    本次服务将在
    <span
      class="time"
      :style="{ color: color, fontSize: fontSize + 'px', fontWeight: 600 }"
      >{{
        hour
          ? hourString + ":" + minuteString + ":" + secondString
          : minuteString + ":" + secondString
      }}</span
    >后结束
  </div>
</template>

<script>
export default {
  data() {
    return {
      hour: "",
      minute: "",
      second: "",
      promiseTimer: "",
      time: "",
    };
  },
  props: {
    remainTime: {
      // 倒计时间总秒数
      default: '',
    },
    color: {
      //字体颜色
      default: "#e0706f",
    },
    fontSize: {
      // 字体大小
      default: 24,
    },
    fontWeight: {
      default: 600,
    },
  },
  mounted() {
    this.time = this.remainTime;
    if (this.remainTime > 0) {
      this.hour = Math.floor((this.remainTime / 3600) % 24);
      this.minute = Math.floor((this.remainTime / 60) % 60);
      this.second = Math.floor(this.remainTime % 60);
      this.countDowm();
    }
  },
  methods: {
    countDowm() {
      var self = this;
      clearInterval(this.promiseTimer);
      this.promiseTimer = setInterval(function () {
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59;
            self.minute -= 1;
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0;
            self.$emit("countDowmEnd", true);
            clearInterval(self.promiseTimer);
          } else {
            self.second -= 1;
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59;
            self.minute -= 1;
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1;
            self.minute = 59;
            self.second = 59;
          } else {
            self.second -= 1;
          }
        }
        self.time -= 1;
      }, 1000);
    },
    formatNum(num) {
      return num < 10 ? "0" + num : "" + num;
    },
  },

  watch: {
    time: {
      immediate: true, // 深度监听
      deep: true,
      handler(val, oldVal) {
        if (val === 0) {
          // 发送倒计时结束事件
          this.$emit("countTimeEnd");
        }
      },
    },
  },
  computed: {
    hourString() {
      return this.formatNum(this.hour);
    },
    minuteString() {
      return this.formatNum(this.minute);
    },
    secondString() {
      return this.formatNum(this.second);
    },
  },
};
</script>
<style scoped>
.time {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/countDown.vue